import { useAppContext } from "../../context/AppState/AppContext";
import PaymentPage from "../../features/PaymentCheckout/PaymentPage/PaymentPage";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import './PaymentCheckout.css';

const PaymentCheckout = () => {
  const {jsonTexts, jsonMedia} = useAppContext();
  const paymentImages = jsonMedia.paymentCheckout;
  const {textData} = jsonTexts.paymentCheckout;
  return (
    <MainLayout overflow="hidden">
        <section className="paymentSuccess__section">
            <PaymentPage paymentImages={paymentImages} textData={textData}/>
        </section>

    </MainLayout>
  )
}
export default PaymentCheckout